<template>
  <div class="container" @click="closeClick">
    <!-- <div class="image-container">
      <img src="@/assets/img/background.png" alt="" />
    </div> -->

    <div class="search-box">
      <el-autocomplete
          class="inline-input"
          v-model="keyword"
          :fetch-suggestions="querySearch"
          placeholder="请输入内容"
          @select="handleSelect"
          :clearable="true"
          :debounce="300"
        >
        <template #prefix> <img class="icon" src="@/assets/img/icon_search.png" /></template>
        <template slot-scope="{ item }">
          <div class="search-item thesis">
            📄 {{ item.value }}
          </div>
        </template>
      </el-autocomplete>
    </div>

    <!-- 关键词列表 -->
    <div class="tag-list-container" v-if="tagList && tagList.length > 0">
      <div class="tag-list-header">
        <div class="tag-list-title">
          相关关键词 ({{ tagList.length }})：
        </div>
        <div class="tag-list-controls">
          <div class="collapse-btn" @click="toggleTagListCollapse" :title="isTagListCollapsed ? '展开关键词列表' : '折叠关键词列表'">
            {{ isTagListCollapsed ? '📂 展开' : '📁 折叠' }}
          </div>
          <div class="analyze-btn" @click="analyzePapers" title="AI分析前10篇论文">
            🤖 智能分析
          </div>

          <div class="reset-btn" @click="resetToOriginalData" title="重置到原始数据">
            🔄 重置
          </div>
        </div>
      </div>
      <div class="tag-list no-scroll-bar" v-show="!isTagListCollapsed">
        <div 
          v-for="(tag, index) in tagList" 
          :key="index" 
          class="tag-item"
          @click="handleTagClick(tag)"
        >
          {{ tag }}
        </div>
      </div>
    </div>

    <div class="paper-chart" ref="paperChart" :class="{ 'has-keywords': tagList && tagList.length > 0 && !isTagListCollapsed }">
      <div class="triangle"></div>
      <div class="no-scroll-bar paper-chart-content" @scroll="handleScroll">
         <div v-for="year in visibleYears" :key="year" class="year-row">
          <div class="paper-chart-year">{{ year }}</div>
          <div class="paper-chart-dot">
            <span 
              v-for="(value, index) in getYearData(year)" 
              :key="`${year}-${value.thesis_id || value.paper_id}-${index}`" 
              class="dot" 
              :class="[
                getPaperDotStyleClass(value),
                {
                  selected: selectedPaperId === (value.thesis_id || value.paper_id) || value.hasKeyword,
                }
              ]"
              :data-paper-id="value.thesis_id || value.paper_id"
              :title="value.thesis_title || value.paper_name"
              @click.stop="handleDotClick(value)">
            </span>
            
            <!-- 加载更多按钮 -->
            <div v-if="checkLoadMore(year)" class="load-more-btn" @click="loadMoreForYear(year)">
              <span v-if="!yearLoadingStates[year]">+{{ getRemainingCount(year) }}</span>
              <span v-else class="loading">...</span>
            </div>
          </div>
        </div>
      </div>
      <div class="circle"></div>
      
    </div>

    <!-- 分类信息 -->
    <div class="category-list no-scroll-bar" v-if="categoryList">
      <div v-for="(item, index) in categoryList" :key="index" class="category-item"
        :class="curClassify == item.classify_id ? 'category-item-active' : ''">
        <div @click="handleClassify(item.classify_id)">
          {{ item.classify_name }}
        </div>
      </div>
    </div>

    <!-- 论文内容 -->
    <div v-if="paperDetails" class="paper-details" @click.stop>
      <div class="paper-details-header">
      <div class="paper-details-title">
        <span v-html="paperDetails.paper_name" @click="clickPaperTitle(paperDetails)"></span>
        </div>
        <div class="paper-details-close" @click="closePaperDetails">
          <span>×</span>
        </div>
      </div>
      <div class="paper-details-doi">
        <span class="paper-details-doi-title">DOI:</span>
        <span v-if="isHttpLink">
          <a :href="paperDetails.paper_link" target="_blank" style="text-decoration: none;color: #ff3905;">{{
            paperDetails.identification_number }}</a>
        </span>
        <span v-else class="paper-details-doi-link">
          <a :href="paperDetails.paper_link" target="_blank" style="text-decoration: none;color: #ff3905;">{{
            paperDetails.identification_number }}</a>
        </span>
      </div>
      <div class="paper-details-author no-scroll-bar">
        <span v-html="paperDetails.paper_author"></span>
      </div>
      <!-- 导读 -->
      <div class="paperIntroduction" v-if="paperIntroductionList.length > 0">
        <div class="paperIntroduction-left">导读</div>
        <div class="paperIntroduction-right no-scroll-bar">
          <div class="paperIntroduction-right-item" v-for="(item, index) in paperIntroductionList" :key="index"
            @click="clickPaperIntroductionList(item)">
            {{ item.title }}
          </div>
        </div>
      </div>
      <!-- 摘要 -->
      <div>
        <div class="paper-details-subtitle">Abstract</div>
        <div class="paper-details-abstract no-scroll-bar" v-if="paperDetails.paper_abstract">
          {{ paperDetails.paper_abstract }}
        </div>
        <div v-else class="paper-details-abstract no-scroll-bar">暂无摘要</div>
      </div>
      <!-- 论文标签 -->
      <div v-if="paperDetails.thesis_tag">
        <div class="paper-details-subtitle">Tags</div>
        <div class="paper-details-tags no-scroll-bar">
          <span v-for="(tag, index) in paperDetails.thesis_tag.split(',')" :key="index" class="tag-item">
            {{ tag.trim() }}
          </span>
          </div>
        </div>
      <!-- 学科分类 -->
      <div v-if="paperDetails.subject_arr && paperDetails.subject_arr.length > 0">
        <div class="paper-details-subtitle">Subjects</div>
        <div class="paper-details-subjects no-scroll-bar">
          <span v-for="(subject, index) in paperDetails.subject_arr" :key="index" class="subject-item">
            {{ subject.thesis_subject_name }}
          </span>
        </div>
      </div>
      <!-- 期刊信息 -->
      <div v-if="paperDetails.journal">
        <div class="paper-details-subtitle">Journal</div>
        <div class="paper-details-journal no-scroll-bar">
          {{ paperDetails.journal.thesis_journal_name }}
        </div>
      </div>

    </div>
    <!-- 分析结果弹窗 -->
    <div class="analysis-modal" v-if="isAnalysisModalVisible && analysisResult">
      <div class="analysis-modal-header">
        <div class="analysis-modal-title">
          AI论文分析结果
        </div>
        <div class="analysis-modal-controls">
          <div class="analysis-modal-minimize" @click="isAnalysisModalVisible = false" title="隐藏分析结果">
            隐藏
          </div>
        </div>
      </div>
      
      <div class="analysis-modal-content">
        <div v-if="analysisResult.success" class="analysis-content">
          <!-- 分析概要 -->
          <div class="analysis-summary" v-if="analysisResult.data.summary">
            <h4>分析概要</h4>
            <div class="summary-stats">
              <span class="stat-item">团队: {{ analysisResult.data.summary.teamCount }}</span>
              <span class="stat-item">成果: {{ analysisResult.data.summary.achievementCount }}</span>
              <span class="stat-item">理论: {{ analysisResult.data.summary.theoryCount }}</span>
              <span class="stat-item">问题: {{ analysisResult.data.summary.problemCount }}</span>
            </div>
          </div>
          
          <!-- 详细分析内容 -->
          <div class="analysis-sections">
            <template v-for="(content, sectionTitle) in analysisResult.data.sections">
              <div 
                v-if="sectionTitle !== '工具说明' && sectionTitle !== '使用说明'"
                :key="sectionTitle"
                class="analysis-section"
              >
                <h4 class="section-title">{{ sectionTitle }}</h4>
                <div class="section-content" v-html="formatSectionContent(content)"></div>
              </div>
            </template>
          </div>
        </div>
        
        <div v-else class="analysis-error">
          <div class="error-message">
            {{ analysisResult.message }}
          </div>
          <div v-if="analysisResult.error" class="error-details">
            {{ analysisResult.error }}
          </div>
        </div>
      </div>
    </div>

    <!-- 分析结果切换按钮（当弹窗隐藏时显示） -->
    <div 
      class="analysis-toggle-btn" 
      v-if="analysisResult && !isAnalysisModalVisible"
      @click="isAnalysisModalVisible = true"
      title="显示分析结果"
    >
      分析结果
    </div>

    <!-- 期刊列表展示区域 -->
    <JournalList @journal-search="handleJournalSearch" ref="journalList" />

    <!-- 按钮 -->
    <drop-welt />
  </div>
</template>

<script lang="js">
import DropWelt from '@/components/dropwelt/index';
import JournalList from '@/components/JournalList.vue';
import request from '@/http/request';
import { Loading } from 'element-ui';
import { analyzePapersWithCoze, createAnalysisLoadingModal, removeAnalysisLoadingModal, highlightPaperDot, removeAllHighlights } from '@/utils/paperAnalysis';

export default {
  components: {
    DropWelt,
    JournalList
  },
  data () {
    return {
      keyword: '',
      dataPage: 1,
      dataLimit: 30,
      paperPage: 1,
      paperLimit: 30,
      thesisPage: 1, // 新增论文分页参数
      maxDataPage: 5, // 默认加载5页年份数据（25年）
      currentMaxPage: 1, // 当前已加载的最大年份页数
      isLoadingYears: false, // 是否正在加载年份数据

      chartData: {},
      yearTotals: {}, // 保存每年的论文总数
      yearThesisPages: {}, // 保存每年已加载的论文页数
      yearLoadingStates: {}, // 保存每年的加载状态

      tooltipLeft: null,
      tooltipTop: null,
      selectedPaperId: -1, // 选中的论文id
      selectedBibliographyNum: -1, // 选中的参考文献num(这个编号需要关联paperid,不是唯一的)
      selectedBibliographyNumPaperId: -1, // 和参考文献关联的
      paperDetails: null,

      isHttpLink: false,

      // 分类
      categoryList: [],
      curClassify: -1,

      // 年份
      maxYear: null,
      minYear: null,

      // 搜索防抖
      timerId: null,

      // 对比搜索的完整数组
      allData: null,

      // 导读数组
      paperIntroductionList: [],
      
      // 懒加载相关
      visibleData: {}, // 当前可见的数据
      loadedCount: {}, // 每年已加载的数量
      batchSize: 1000, // 每批加载的数量
      isLoading: false,
      
      // 关键词标签相关
      tagList: [], // 关键词标签列表
      isTagListCollapsed: false, // 关键词列表是否折叠
      
      // 分析结果相关
      analysisResult: null, // 分析结果数据
      isAnalysisModalVisible: false, // 分析结果弹窗是否可见
      
      // 虚拟滚动相关
      scrollTop: 0,
      containerHeight: 500,
      yearRowHeight: 36, // 每个年份行的大概高度
      scrollTimer: null, // 滚动防抖定时器
      
      // 论文分类相关
      thesisSubjectList: [], // 论文分类列表
      isSubjectListCollapsed: true, // 分类列表是否折叠（默认折叠）
      selectedSubjectId: null // 当前选中的分类ID
    }
  },
  methods: {
    handleSelect (item) {
      if (item && item.type === 'thesis') {
        // 论文类型：显示详情和在时间轴上高亮
        this.selectedPaperId = item.thesis_id
        this.getPaperDetails(this.selectedPaperId)
        
        // 在时间轴上高亮显示这个论文
        this.highlightPaperInTimeline(item)
        
        // 添加高亮圈选效果
        this.$nextTick(() => {
          highlightPaperDot(item.thesis_id.toString())
        })
      }
    },
    
    // 根据关键词搜索论文
    async searchPapersByKeyword (keyword) {
      this.keyword = keyword
      this.selectedPaperId = -1
      this.paperDetails = null
      this.thesisPage = 1 // 重置论文分页
      this.currentMaxPage = 1 // 重置年份分页
      this.yearTotals = {} // 重置年份总数
      this.yearThesisPages = {} // 重置年份论文页数
      this.yearLoadingStates = {} // 重置年份加载状态
      
      try {
        this.showLoading()
        
        const response = await request('/api/Thesis/getThesisList', {
          search: keyword,
          page: 1,
          thesis_page: this.thesisPage // 使用论文分页参数
        })
        
        console.log('搜索API响应:', response)
        
        // 处理响应格式 - API直接返回年份数据对象
        let yearData = null
        
        if (response && typeof response === 'object') {
          // 检查是否为包装格式 {code: 200, result: {...}}
          if (response.code === 200 && response.result) {
            yearData = response.result
          } else if (Object.keys(response).some(key => !isNaN(parseInt(key)))) {
            // 直接返回年份数据对象（键为年份数字）
            yearData = response
          } else {
            console.warn('API响应格式异常:', response)
          }
        } else {
          console.warn('API响应格式异常:', response)
        }
        
        if (yearData && Object.keys(yearData).length > 0) {
          // 处理数据格式，适配新的API响应结构
          const processedData = {}
          let totalPapers = 0
          
          for (const year in yearData) {
            // 新API返回格式：{year: {total: number, data: array}}
            if (yearData[year] && yearData[year].data && Array.isArray(yearData[year].data) && yearData[year].data.length > 0) {
              processedData[year] = yearData[year].data.map(item => ({
                paper_id: item.thesis_id,
                paper_name: item.thesis_title,
                thesis_id: item.thesis_id,
                thesis_title: item.thesis_title,
                thesis_publish_year: item.thesis_publish_year || parseInt(year),
                hasKeyword: true // 标记为包含关键词
              }))
              totalPapers += yearData[year].data.length
            }
          }
          
          // 获取年份范围
          const dataYears = Object.keys(processedData).map(year => parseInt(year))
          if (dataYears.length > 0) {
            this.minYear = Math.min(...dataYears)
            this.maxYear = Math.max(...dataYears)
            
            // 更新图表数据
            this.$set(this, 'chartData', processedData)
            // 初始化懒加载数据
            this.initLazyLoading(processedData)
            
            this.$message({
              message: `找到 ${totalPapers} 篇包含关键词"${keyword}"的论文`,
              type: 'success',
              duration: 2000
            })
          } else {
            this.$set(this, 'chartData', {})
            this.$message({
              message: `未找到包含关键词"${keyword}"的论文`,
              type: 'info',
              duration: 2000
            })
          }
        } else {
          this.$set(this, 'chartData', {})
          this.$message({
            message: `未找到包含关键词"${keyword}"的论文`,
            type: 'info',
            duration: 2000
          })
        }
        
        this.hideLoading()
      } catch (error) {
        console.error('论文搜索失败:', error)
        this.hideLoading()
        this.$message({
          message: '搜索失败，请稍后重试',
          type: 'error',
          duration: 2000
        })
      }
    },
    querySearch (val, cb) {
      if (!val || !val.trim()) {
            cb([])
        this.tagList = [] // 清空关键词列表
        return
      }
      
      // 同时调用两个接口
      const thesisPromise = request('/api/Thesis/getApiThesisList', {
        search: val,
        page: 1
      })
      
      const tagPromise = request('/api/Thesis/getTagList', {
        search: val
      })
      
      Promise.allSettled([thesisPromise, tagPromise]).then((results) => {
        const [thesisResult, tagResult] = results
        
        // 处理论文搜索结果 - 用于下拉框显示
        let thesisOptions = []
        if (thesisResult.status === 'fulfilled' && thesisResult.value && Array.isArray(thesisResult.value)) {
          thesisOptions = thesisResult.value.map((item) => ({
            ...item,
            value: item.thesis_title,
            title: item.thesis_title,
            thesis_id: item.thesis_id,
            type: 'thesis'
          }))

        }
        
        // 处理关键词标签搜索结果 - 用于页面按钮显示
        if (tagResult.status === 'fulfilled') {
          let keywords = []
          
          if (Array.isArray(tagResult.value) && tagResult.value.length > 0) {
            keywords = tagResult.value
          } else if (tagResult.value && tagResult.value.code === 200 && Array.isArray(tagResult.value.result)) {
            keywords = tagResult.value.result
          }
          
          this.tagList = keywords.length > 0 ? keywords : []
        } else {
          this.tagList = []
        }
        
        // 只将论文结果返回给下拉框
        cb(thesisOptions)
        
        }).catch((error) => {
          console.error('搜索请求失败:', error)
        this.tagList = []
          cb([])
        })
    },
    
    // 处理关键词点击事件（页面上的关键词标签）
    handleTagClick (tag) {
      this.searchPapersByKeyword(tag)
    },
    
    // 切换关键词列表的折叠状态
    toggleTagListCollapse () {
      this.isTagListCollapsed = !this.isTagListCollapsed
    },
    
    // AI分析论文
    async analyzePapers () {
      try {
        // 获取当前时间轴中的前10篇论文ID
        const paperIds = this.getTop10PaperIds()
        
        if (paperIds.length === 0) {
          this.$message({
            message: '当前没有论文数据可供分析',
            type: 'warning',
            duration: 2000
          })
          return
        }
        
        console.log('准备分析的论文IDs:', paperIds)
        
        // 显示加载提示
        createAnalysisLoadingModal()
        
        // 调用分析功能
        const result = await analyzePapersWithCoze(paperIds)
        
        // 移除加载提示
        removeAnalysisLoadingModal()
        
        // 检查分析结果
        if (result && result.success) {
          // 保存分析结果并显示弹窗
          this.analysisResult = result
          this.isAnalysisModalVisible = true
          
          // 显示成功消息
          this.$message({
            message: `成功分析了 ${paperIds.length} 篇论文`,
            type: 'success',
            duration: 3000
          })
        } else {
          // 分析失败但没有抛出异常
          this.$message({
            message: result?.message || '分析结果解析失败',
            type: 'warning',
            duration: 5000
          })
        }
        
      } catch (error) {
        // 移除加载提示
        removeAnalysisLoadingModal()
        
        console.error('论文分析失败:', error)
        
        // 根据错误类型提供不同的提示
        let errorMessage = '分析失败，请稍后重试'
        let showRetry = false
        
        if (error.message.includes('5000')) {
          errorMessage = 'Coze工作流系统异常，请稍后重试'
          showRetry = true
        } else if (error.message.includes('401')) {
          errorMessage = '认证失败，请检查权限设置'
        } else if (error.message.includes('6031')) {
          errorMessage = '工作流未发布，请检查工作流状态'
        } else {
          errorMessage = `分析失败: ${error.message}`
        }
        
        this.$message({
          message: errorMessage,
          type: 'error',
          duration: showRetry ? 8000 : 5000,
          showClose: true
        })
        
        // 如果是系统异常，提供重试提示
        if (showRetry) {
          setTimeout(() => {
            this.$message({
              message: '💡 提示：5000错误通常是服务端临时问题，建议等待1-2分钟后重试',
              type: 'info',
              duration: 6000,
              showClose: true
            })
          }, 2000)
        }
      }
    },
    
    // 获取前10篇论文ID
    getTop10PaperIds () {
      const paperIds = []
      
      // 按年份降序遍历，收集论文ID
      const sortedYears = Object.keys(this.chartData).sort((a, b) => b - a)
      
      for (const year of sortedYears) {
        const yearPapers = this.chartData[year] || []
        for (const paper of yearPapers) {
          if (paperIds.length < 10) {
            paperIds.push(paper.thesis_id || paper.paper_id)
      } else {
            break
          }
        }
        if (paperIds.length >= 10) break
      }
      
      return paperIds
    },
    
    // 获取分析部分的图标
    getSectionIcon (sectionTitle) {
      const iconMap = {
        '团队': '👥',
        '成果': '🎯', 
        '理论': '💡',
        '问题': '❓',
        '未来研究方向': '🔮'
      }
      return iconMap[sectionTitle] || '📄'
    },
    
    // 格式化分析内容
    formatSectionContent (content) {
      if (!content) return ''
      
      // 将换行符转换为HTML换行
      let formatted = content.replace(/\n/g, '<br>')
      
      // 加粗处理：将 **文本** 转换为 <strong>文本</strong>
      formatted = formatted.replace(/\*\*(.*?)\*\*/g, '<strong>$1</strong>')
      
      // 处理编号列表：1. 2. 3. 等
      formatted = formatted.replace(/^(\d+\.\s)/gm, '<strong>$1</strong>')
      
      // 处理项目符号：① ② ③ 等
      formatted = formatted.replace(/([①②③④⑤⑥⑦⑧⑨⑩])/g, '<strong>$1</strong>')
      
      return formatted
    },
    

    // 处理期刊搜索事件
    async handleJournalSearch (journal) {
      console.log('处理期刊搜索:', journal)
      
      // 重置相关状态
      this.keyword = ''
      this.tagList = []
      this.selectedPaperId = -1
      this.paperDetails = null
      this.thesisPage = 1
      this.currentMaxPage = 1
      this.yearTotals = {}
      this.yearThesisPages = {}
      this.yearLoadingStates = {}
      
      // 移除所有高亮效果
      removeAllHighlights()
      
      if (!journal) {
        // 如果没有选择期刊，恢复到原始数据
        this.resetToOriginalData()
        return
      }
      
      try {
        this.showLoading()
        
        // 调用期刊搜索接口
        const response = await request('/api/Thesis/getThesisList', {
          journal_id: journal.thesis_journal_id,
          page: 1,
          thesis_page: this.thesisPage
        })
        
        console.log('期刊搜索API响应:', response)
        
        // 处理响应格式 - API直接返回年份数据对象
        let yearData = null
        
        if (response && typeof response === 'object') {
          // 检查是否为包装格式 {code: 200, result: {...}}
          if (response.code === 200 && response.result) {
            yearData = response.result
          } else if (Object.keys(response).some(key => !isNaN(parseInt(key)))) {
            // 直接返回年份数据对象（键为年份数字）
            yearData = response
          } else {
            console.warn('期刊搜索API响应格式异常:', response)
          }
        } else {
          console.warn('期刊搜索API响应格式异常:', response)
        }
        
        if (yearData && Object.keys(yearData).length > 0) {
          // 处理数据格式，适配新的API响应结构
          const processedData = {}
          let totalPapers = 0
          
          for (const year in yearData) {
            // 新API返回格式：{year: {total: number, data: array}}
            if (yearData[year] && yearData[year].data && Array.isArray(yearData[year].data) && yearData[year].data.length > 0) {
              processedData[year] = yearData[year].data.map(item => ({
                paper_id: item.thesis_id,
                paper_name: item.thesis_title,
                thesis_id: item.thesis_id,
                thesis_title: item.thesis_title,
                thesis_publish_year: item.thesis_publish_year || parseInt(year),
                hasKeyword: false // 期刊筛选不标记关键词
              }))
              totalPapers += yearData[year].data.length
              
              // 保存年份总数信息
              this.yearTotals[year] = yearData[year].total
              this.yearThesisPages[year] = 1
            }
          }
          
          // 获取年份范围
          const dataYears = Object.keys(processedData).map(year => parseInt(year))
          if (dataYears.length > 0) {
            this.minYear = Math.min(...dataYears)
            this.maxYear = Math.max(...dataYears)
            
            // 更新图表数据
            this.$set(this, 'chartData', processedData)
            // 初始化懒加载数据
            this.initLazyLoading(processedData)
            
            this.$message({
              message: `找到 ${totalPapers} 篇来自"${journal.thesis_journal_name}"期刊的论文`,
              type: 'success',
              duration: 2000
            })
          } else {
            this.$set(this, 'chartData', {})
            this.$message({
              message: `未找到来自"${journal.thesis_journal_name}"期刊的论文`,
              type: 'info',
              duration: 2000
            })
          }
        } else {
          this.$set(this, 'chartData', {})
          this.$message({
            message: `未找到来自"${journal.thesis_journal_name}"期刊的论文`,
            type: 'info',
            duration: 2000
          })
        }
        
        this.hideLoading()
      } catch (error) {
        console.error('期刊搜索失败:', error)
        this.hideLoading()
        this.$message({
          message: '期刊搜索失败，请稍后重试',
          type: 'error',
          duration: 2000
        })
      }
    },

    // 重置到原始数据
    resetToOriginalData () {
      this.keyword = ''
      this.tagList = []
      this.isTagListCollapsed = false
      this.selectedPaperId = -1
      this.paperDetails = null
      this.selectedSubjectId = null // 重置分类选择
      this.thesisPage = 1 // 重置论文分页
      this.currentMaxPage = 1 // 重置年份分页
      this.yearTotals = {} // 重置年份总数
      this.yearThesisPages = {} // 重置年份论文页数
      this.yearLoadingStates = {} // 重置年份加载状态
      
      // 重置期刊列表选择
      if (this.$refs.journalList) {
        this.$refs.journalList.resetSelection()
      }
      
      // 移除所有高亮效果
      removeAllHighlights()
      
      if (this.allData) {
        const restoredData = JSON.parse(JSON.stringify(this.allData))
        this.$set(this, 'chartData', restoredData)
        this.initLazyLoading(restoredData)
      } else {
        // 如果没有原始数据，重新获取
        this.getData()
      }
    },
    
    // 在时间轴上高亮显示论文
    highlightPaperInTimeline (selectedPaper) {
      // 遍历所有年份的数据，找到匹配的论文并标记为高亮
      const newChartData = JSON.parse(JSON.stringify(this.chartData))
      let found = false
      
      for (const year in newChartData) {
        if (newChartData[year] && newChartData[year].length > 0) {
          newChartData[year] = newChartData[year].map(item => {
            if (item.thesis_id === selectedPaper.thesis_id || item.paper_id === selectedPaper.thesis_id) {
              found = true
              return { ...item, hasKeyword: true, isSelected: true }
            }
            return { ...item, hasKeyword: false, isSelected: false }
          })
        }
      }
      
      if (found) {
        this.$set(this, 'chartData', newChartData)
      } else {
        // 如果在当前数据中找不到，恢复完整数据并高亮
        if (this.allData) {
          const fullData = JSON.parse(JSON.stringify(this.allData))
          for (const year in fullData) {
            if (fullData[year] && fullData[year].length > 0) {
              fullData[year] = fullData[year].map(item => {
                if (item.thesis_id === selectedPaper.thesis_id || item.paper_id === selectedPaper.thesis_id) {
                  return { ...item, hasKeyword: true, isSelected: true }
                }
                return { ...item, hasKeyword: false, isSelected: false }
              })
            }
          }
          this.$set(this, 'chartData', fullData)
        }
      }
    },
    
    // 根据关键词过滤数据
    filterDataByKeyword (keyword) {
      console.log('本地过滤数据，关键词:', keyword)
      if (!this.allData || !keyword) {
        return
      }
      
      const filteredData = {}
      const lowerKeyword = keyword.toLowerCase()
      
      // 遍历所有年份的数据
      for (const year in this.allData) {
        const yearData = this.allData[year]
        if (yearData && yearData.length > 0) {
          // 过滤包含关键词的论文
          const filtered = yearData.filter(item => {
            const title = item.thesis_title || item.paper_name || ''
            return title.toLowerCase().includes(lowerKeyword)
          }).map(item => ({
            ...item,
            hasKeyword: true // 标记为包含关键词
          }))
          
          if (filtered.length > 0) {
            filteredData[year] = filtered
          }
        }
      }
      
      console.log('过滤后的数据:', filteredData)
      console.log('包含关键词的年份:', Object.keys(filteredData))
      
      // 更新图表数据
      this.$set(this, 'chartData', filteredData)
      // 重新初始化懒加载数据
      this.initLazyLoading(filteredData)
    },
    
    // 初始化懒加载数据
    initLazyLoading (fullData) {
      console.log('初始化懒加载数据')
      const visibleData = {}
      const loadedCount = {}
      
      // 为每年初始化数据 - 显示所有数据，不再限制为batchSize
      for (const year in fullData) {
        if (fullData[year] && fullData[year].length > 0) {
          // 显示所有数据，不再限制为前batchSize条
          visibleData[year] = fullData[year]
          loadedCount[year] = fullData[year].length
          
          console.log(`${year}年加载${fullData[year].length}篇论文`)
        }
      }
      
      this.$set(this, 'visibleData', visibleData)
      this.$set(this, 'loadedCount', loadedCount)
    },
    
    // 加载更多数据（调用API加载特定年份的下一页）
    async loadMoreForYear (year) {
      if (this.yearLoadingStates[year]) return
      
      // 检查是否还有更多数据可加载
      const currentLoaded = (this.chartData[year] || []).length
      const total = this.yearTotals[year] || 0
      
      if (currentLoaded >= total) {
        console.log(`${year}年已加载完所有数据`)
        return
      }
      
      this.$set(this.yearLoadingStates, year, true)
      
      try {
        // 获取该年份的下一页论文页数
        const currentThesisPage = this.yearThesisPages[year] || 1
        
        console.log(`加载${year}年更多论文数据，当前已加载到第${currentThesisPage}页...`)
        
        // 构建API参数 - 需要找到包含该年份的年份页
        const yearNum = parseInt(year)
        const yearPage = Math.ceil((2025 - yearNum + 1) / 5) // 根据年份计算对应的年份页
        
        // 为了获取约100篇论文，我们需要加载多页（每页30篇，加载3-4页）
        const pagesToLoad = 4 // 加载4页，约120篇论文
        let allNewData = []
        let actualPagesLoaded = 0
        
        for (let i = 1; i <= pagesToLoad; i++) {
          const nextThesisPage = currentThesisPage + i
          
          const params = {
            page: yearPage,
            thesis_page: nextThesisPage
          }
          
          if (this.curClassify !== -1) {
            params.classify_id = this.curClassify
          }
          
          if (this.keyword) {
            params.search = this.keyword
          }
          
          console.log(`加载${year}年第${nextThesisPage}页论文数据...`)
          const response = await request('/api/Thesis/getThesisList', params)
          console.log(`${year}年第${nextThesisPage}页API响应:`, response)
          
          // 处理响应格式
          if (response && typeof response === 'object') {
            let responseData = null
            if (response.code === 200 && response.result) {
              responseData = response.result
            } else if (Object.keys(response).some(key => !isNaN(parseInt(key)))) {
              responseData = response
            }
            
            if (responseData && responseData[year] && responseData[year].data && Array.isArray(responseData[year].data)) {
              const pageData = responseData[year].data.map(item => Object.freeze({
                paper_id: item.thesis_id,
                paper_name: item.thesis_title,
                thesis_id: item.thesis_id,
                thesis_title: item.thesis_title,
                thesis_publish_year: item.thesis_publish_year,
                hasKeyword: this.keyword && item.thesis_title.toLowerCase().includes(this.keyword.toLowerCase())
              }))
              
              // 收集所有页面的数据
              allNewData = [...allNewData, ...pageData]
              actualPagesLoaded++
              
              console.log(`${year}年第${nextThesisPage}页获取到${pageData.length}篇论文`)
            } else {
              console.log(`${year}年第${nextThesisPage}页没有数据，停止加载`)
              break // 如果某页没有数据，停止加载后续页面
            }
          } else {
            console.error(`${year}年第${nextThesisPage}页API响应格式异常:`, response)
            break // 如果API响应异常，停止加载
          }
        }
        
        // 处理合并后的所有数据
        if (allNewData.length > 0) {
          // 合并到现有年份数据并去重
          if (this.chartData[year]) {
            const existingData = [...this.chartData[year]]
            const newItems = this.deduplicateByThesisId(existingData, allNewData)
            if (newItems.length > 0) {
              const updatedData = [...existingData, ...newItems]
              this.$set(this.chartData, year, Object.freeze(updatedData))
              this.$set(this.yearThesisPages, year, currentThesisPage + actualPagesLoaded)
              
              // 直接更新visibleData和loadedCount，而不是重新初始化所有年份
              this.$set(this.visibleData, year, updatedData)
              this.$set(this.loadedCount, year, updatedData.length)
              
              console.log(`${year}年成功加载${actualPagesLoaded}页，新增${newItems.length}篇论文，当前共${updatedData.length}篇`)
              
              this.$message({
                message: `${year}年成功加载${newItems.length}篇新论文`,
                type: 'success',
                duration: 2000
              })
            } else {
              console.log(`${year}年加载的${allNewData.length}篇论文都是重复的`)
              this.$message({
                message: `${year}年没有更多新数据了`,
                type: 'info',
                duration: 2000
              })
            }
          }
        } else {
          console.log(`${year}年没有获取到任何新数据`)
          this.$message({
            message: `${year}年没有更多数据了`,
            type: 'info',
            duration: 2000
          })
        }
      } catch (error) {
        console.error(`加载${year}年更多数据失败:`, error)
        this.$message({
          message: '加载失败，请稍后重试',
          type: 'error',
          duration: 2000
        })
      }
      
      this.$set(this.yearLoadingStates, year, false)
    },
    
    
    // 检查是否需要加载更多（基于API总数）
    checkLoadMore (year) {
      const currentLoaded = (this.chartData[year] || []).length
      const total = this.yearTotals[year] || 0
      return currentLoaded < total
    },
    
    // 获取剩余条数
    getRemainingCount (year) {
      const currentLoaded = (this.chartData[year] || []).length
      const total = this.yearTotals[year] || 0
      return Math.max(0, total - currentLoaded)
    },
    
    // 去重辅助函数
    deduplicateByThesisId (existingData, newData) {
      const existingIds = new Set(existingData.map(item => item.thesis_id))
      const uniqueNewData = newData.filter(item => !existingIds.has(item.thesis_id))
      
      if (newData.length !== uniqueNewData.length) {
        console.log(`去重：${newData.length}篇 → ${uniqueNewData.length}篇，跳过${newData.length - uniqueNewData.length}篇重复`)
      }
      
      return uniqueNewData
    },
    
    // 获取年份显示的数据（用于模板）- 优化版本使用缓存
    getYearData (year) {
      return this.cachedYearData[year] || []
    },
    
    // 防抖滚动处理
    handleScroll (event) {
      clearTimeout(this.scrollTimer)
      this.scrollTimer = setTimeout(() => {
        this.scrollTop = event.target.scrollTop
        
        // 检查是否滚动到接近底部，如果是则加载更多年份数据
        const { scrollTop, scrollHeight, clientHeight } = event.target
        const scrollPercentage = (scrollTop + clientHeight) / scrollHeight
        
        // 当滚动到80%时，自动加载更多年份
        if (scrollPercentage > 0.8 && !this.isLoadingYears) {
          this.loadMoreYears()
        }
      }, 10)
    },
    
    // 加载更多年份数据
    async loadMoreYears() {
      if (this.isLoadingYears) return
      
      this.isLoadingYears = true
      console.log(`开始加载第${this.currentMaxPage + 1}页年份数据...`)
      
      try {
        const nextPage = this.currentMaxPage + 1
        const params = {
          page: nextPage,
          thesis_page: this.thesisPage
        }
        
        if (this.curClassify !== -1) {
          params.classify_id = this.curClassify
        }
        
        if (this.keyword) {
          params.search = this.keyword
        }
        
        console.log('加载更多年份，发送API请求，参数:', params)
        const response = await request('/api/Thesis/getThesisList', params)
        console.log(`第${nextPage}页年份API响应:`, response)
        
        // 处理响应格式
        if (response && typeof response === 'object') {
          let responseData = null
          if (response.code === 200 && response.result) {
            responseData = response.result
          } else if (Object.keys(response).some(key => !isNaN(parseInt(key)))) {
            responseData = response
          }
          
          if (responseData && Object.keys(responseData).length > 0) {
            // 合并新的年份数据到现有数据
            const newChartData = { ...this.chartData }
            let hasNewData = false
            
            for (const year in responseData) {
              if (responseData[year] && responseData[year].data && Array.isArray(responseData[year].data) && responseData[year].data.length > 0) {
                const yearData = responseData[year].data.map(item => Object.freeze({
                  paper_id: item.thesis_id,
                  paper_name: item.thesis_title,
                  thesis_id: item.thesis_id,
                  thesis_title: item.thesis_title,
                  thesis_publish_year: item.thesis_publish_year,
                  hasKeyword: this.keyword && item.thesis_title.toLowerCase().includes(this.keyword.toLowerCase())
                }))
                
                // 保存年份总数信息和初始论文页数
                if (!this.yearTotals[year]) {
                  this.$set(this.yearTotals, year, responseData[year].total)
                  this.$set(this.yearThesisPages, year, 1) // 初始化为第1页
                }
                
                // 如果年份已存在，合并数据并去重；否则直接设置
                if (newChartData[year]) {
                  const newItems = this.deduplicateByThesisId(newChartData[year], yearData)
                  if (newItems.length > 0) {
                    newChartData[year] = Object.freeze([...newChartData[year], ...newItems])
                    hasNewData = true
                    console.log(`第${nextPage}页 ${year}年新增${newItems.length}篇论文（去重后）`)
                  }
                } else {
                  newChartData[year] = Object.freeze(yearData)
                  hasNewData = true
                  console.log(`第${nextPage}页 ${year}年新增${yearData.length}篇论文（新年份）`)
                }
              }
            }
            
            if (hasNewData) {
              // 更新数据和年份范围
              const dataYears = Object.keys(newChartData).map(year => parseInt(year))
              this.minYear = Math.min(this.minYear || Infinity, ...dataYears)
              this.maxYear = Math.max(this.maxYear || -Infinity, ...dataYears)
              
              this.$set(this, 'chartData', newChartData)
              
              // 更新懒加载数据
              this.initLazyLoading(newChartData)
              
              this.currentMaxPage = nextPage
              
              console.log(`成功加载第${nextPage}页年份数据，当前共${Object.keys(newChartData).length}个年份`)
              
              // 静默成功，不显示消息避免打扰用户
            } else {
              console.log(`第${nextPage}页没有新的年份数据`)
            }
          } else {
            console.log(`第${nextPage}页没有更多年份数据了`)
          }
        } else {
          console.error(`第${nextPage}页年份API响应格式异常:`, response)
        }
      } catch (error) {
        console.error('加载更多年份失败:', error)
        // 静默处理错误，不显示错误消息避免打扰用户
      }
      
      this.isLoadingYears = false
    },
    
    // 获取数据
    async getData (classifyId) {
      console.log('开始获取数据，classifyId:', classifyId)
      this.thesisPage = 1 // 重置论文分页
      this.currentMaxPage = 1 // 重置年份分页
      this.yearTotals = {} // 重置年份总数
      this.yearThesisPages = {} // 重置年份论文页数
      this.yearLoadingStates = {} // 重置年份加载状态
      this.showLoading()
      
      // 合并所有年份数据
      const allYearData = {}
      
      try {
        // 加载前5页年份数据（25年）
        for (let page = 1; page <= this.maxDataPage; page++) {
          console.log(`加载第${page}页年份数据...`)
          
          const params = {
            page: page,
            thesis_page: this.thesisPage
          }

          if (classifyId) {
            params.classify_id = classifyId
          }
          
          // 移除搜索参数，因为我们使用本地过滤
          console.log('发送API请求，参数:', params)
          const response = await request('/api/Thesis/getThesisList', params)
          console.log(`第${page}页API响应:`, response)
          
          // 处理响应格式 - API直接返回年份数据对象
          if (response && typeof response === 'object') {
            // 检查是否为包装格式 {code: 200, result: {...}}
            let responseData = null
            if (response.code === 200 && response.result) {
              responseData = response.result
            } else if (Object.keys(response).some(key => !isNaN(parseInt(key)))) {
              // 直接返回年份数据对象（键为年份数字）
              responseData = response
            }
            
            if (responseData) {
              // 合并年份数据
              for (const year in responseData) {
                if (responseData[year] && responseData[year].data && Array.isArray(responseData[year].data) && responseData[year].data.length > 0) {
                  // 转换数据格式以适配现有组件
                  const yearData = responseData[year].data.map(item => Object.freeze({
                    paper_id: item.thesis_id,
                    paper_name: item.thesis_title,
                    thesis_id: item.thesis_id,
                    thesis_title: item.thesis_title,
                    thesis_publish_year: item.thesis_publish_year,
                    hasKeyword: this.keyword && item.thesis_title.toLowerCase().includes(this.keyword.toLowerCase())
                  }))
                  
                  // 保存年份总数信息和初始论文页数
                  if (!this.yearTotals[year]) {
                    this.yearTotals[year] = responseData[year].total
                    this.yearThesisPages[year] = 1 // 初始化为第1页
                  }
                  
                  // 如果年份已存在，合并数据并去重；否则直接设置
                  if (allYearData[year]) {
                    const newItems = this.deduplicateByThesisId(allYearData[year], yearData)
                    allYearData[year] = [...allYearData[year], ...newItems]
                  } else {
                    allYearData[year] = yearData
                  }
                  
                  console.log(`第${page}页 ${year}年新增${yearData.length}篇论文，总数${responseData[year].total}`)
                }
              }
            } else {
              console.warn(`第${page}页API响应数据为空:`, response)
              break // 如果某页没有数据，停止加载后续页面
            }
          } else {
            console.error(`第${page}页API响应格式异常:`, response)
            break // 如果API响应异常，停止加载
          }
          
          this.currentMaxPage = page
        }
        
        // 处理合并后的所有年份数据
        if (Object.keys(allYearData).length > 0) {
          // 获取实际有数据的年份范围
          const dataYears = Object.keys(allYearData).map(year => parseInt(year))
          console.log('所有加载的数据年份:', dataYears)
          
          const minDataYear = Math.min(...dataYears)
          const maxDataYear = Math.max(...dataYears)
          console.log('年份范围:', minDataYear, '-', maxDataYear)
          
          // 设置合理的年份范围
          this.minYear = minDataYear
          this.maxYear = maxDataYear

          // 冻结数据以提高性能
          const finalData = {}
          for (const year in allYearData) {
            finalData[year] = Object.freeze(allYearData[year])
          }
          
          console.log('最终处理后的数据年份:', Object.keys(finalData).filter(year => finalData[year].length > 0))
          
          // 使用 Vue.set 确保响应式更新
          this.$set(this, 'chartData', finalData)
          if (!classifyId && !this.keyword) {
            this.allData = JSON.parse(JSON.stringify(finalData))
          }
          
          // 初始化懒加载数据
          this.initLazyLoading(finalData)
          
          this.hideLoading()
          
          this.$message({
            message: `成功加载${this.currentMaxPage}页年份数据，共${Object.keys(finalData).length}个年份`,
            type: 'success',
            duration: 2000
          })
        } else {
          this.hideLoading()
          console.log('没有找到任何数据年份')
          this.$set(this, 'chartData', {})
          this.$message({
            message: '没有找到任何数据',
            type: 'info',
            duration: 2000
          })
        }
      } catch (error) {
        console.error('API请求失败:', error)
        this.hideLoading()
        this.$message({
          message: '请求失败: ' + (error.message || error),
          type: 'error',
          duration: 1000
        })
      }
    },

    // 合并对象（保留此方法以防后续需要）
    mergeData (data1, data2) {
      // 创建一个空对象作为合并结果
      const mergedData = {}

      // 合并 data1
      for (const key in data1) {
        // 直接将键值赋给 mergedData
        mergedData[key] = mergedData[key]
          ? mergedData[key].concat(data1[key])
          : data1[key]
      }

      // 合并 data2
      for (const key in data2) {
        // 直接将键值赋给 mergedData
        mergedData[key] = mergedData[key]
          ? mergedData[key].concat(data2[key])
          : data2[key]
      }

      return mergedData
    },
    // 获得分类信息（暂时保留，可能需要更新为新的分类接口）
    async getCategoryList () {
      // 暂时注释掉，等待新的分类接口
      // request('api/Paper/getCategoryList').then((result) => {
      //   this.categoryList = result
      // }).catch((result) => {
      //   this.$message({
      //     message: result.message,
      //     type: 'error',
      //     duration: 1000
      //   })
      // })
      this.categoryList = [] // 暂时设为空数组
    },

    // 获取论文分类列表
    async getThesisSubjectList () {
      try {
        const response = await request('/api/Subspecialty/getMajorList')
        console.log('论文分类API响应:', response)
        
        if (response && response.code === 200 && Array.isArray(response.result)) {
          // 提取所有父分类的children数组,并扁平化为一维数组
          const subjectList = []
          response.result.forEach(parentCategory => {
            if (parentCategory.children && Array.isArray(parentCategory.children)) {
              parentCategory.children.forEach(child => {
                subjectList.push({
                  thesis_subject_id: child.major_id,
                  thesis_subject_name: child.major_name,
                  parent_id: child.parent_id,
                  status: child.status
                })
              })
            }
          })
          this.thesisSubjectList = subjectList
          console.log('论文分类数据:', this.thesisSubjectList)
        } else if (Array.isArray(response)) {
          // 兼容直接返回数组的情况
          const subjectList = []
          response.forEach(parentCategory => {
            if (parentCategory.children && Array.isArray(parentCategory.children)) {
              parentCategory.children.forEach(child => {
                subjectList.push({
                  thesis_subject_id: child.major_id,
                  thesis_subject_name: child.major_name,
                  parent_id: child.parent_id,
                  status: child.status
                })
              })
            }
          })
          this.thesisSubjectList = subjectList
        } else {
          console.warn('论文分类API响应格式异常:', response)
          this.thesisSubjectList = []
        }
      } catch (error) {
        console.error('获取论文分类失败:', error)
        this.thesisSubjectList = []
        this.$message({
          message: '获取论文分类失败',
          type: 'error',
          duration: 2000
        })
      }
    },

    // 切换分类列表的折叠状态
    toggleSubjectListCollapse () {
      this.isSubjectListCollapsed = !this.isSubjectListCollapsed
    },

    // 处理分类点击事件
    handleSubjectClick (subject) {
      console.log('点击分类:', subject)
      
      // 如果点击的是已选中的分类，则取消选中
      if (this.selectedSubjectId === subject.thesis_subject_id) {
        this.selectedSubjectId = null
        this.resetToOriginalData() // 恢复到原始数据
        this.$message({
          message: '已取消分类筛选',
          type: 'info',
          duration: 2000
        })
      } else {
        // 选中新的分类
        this.selectedSubjectId = subject.thesis_subject_id
        this.loadSubjectData(subject.thesis_subject_id, subject.thesis_subject_name)
      }
    },

    // 加载指定分类的论文数据
    async loadSubjectData (subjectId, subjectName) {
      console.log(`开始加载分类"${subjectName}"(ID: ${subjectId})的论文数据`)
      
      // 重置相关状态
      this.keyword = ''
      this.tagList = []
      this.selectedPaperId = -1
      this.paperDetails = null
      this.thesisPage = 1
      this.currentMaxPage = 1
      this.yearTotals = {}
      this.yearThesisPages = {}
      this.yearLoadingStates = {}
      
      try {
        this.showLoading()
        
        // 调用getData方法，传入分类ID
        await this.getData(subjectId)
        
        this.$message({
          message: `已切换到"${subjectName}"分类`,
          type: 'success',
          duration: 2000
        })
      } catch (error) {
        console.error('加载分类数据失败:', error)
        this.$message({
          message: '加载分类数据失败，请稍后重试',
          type: 'error',
          duration: 2000
        })
      }
    },

    // 获取分类样式类名（10种样式循环）
    getSubjectStyleClass (index) {
      return `subject-style-${(index % 10) + 1}`
    },

    // 获取论文点的样式类名
    getPaperDotStyleClass (paper) {
      // 如果当前有选中的分类，则所有论文点使用相同的样式
      if (this.selectedSubjectId && this.thesisSubjectList.length > 0) {
        const selectedIndex = this.thesisSubjectList.findIndex(subject => subject.thesis_subject_id === this.selectedSubjectId)
        if (selectedIndex !== -1) {
          return this.getSubjectStyleClass(selectedIndex)
        }
      }
      
      // 如果没有选中分类，基于论文ID哈希分配样式，创造视觉多样性
      if (this.thesisSubjectList.length > 0) {
        const paperId = paper.thesis_id || paper.paper_id
        if (paperId) {
          // 使用论文ID生成一个伪随机索引来分配样式
          const hash = Math.abs(paperId.toString().split('').reduce((a, b) => {
            a = ((a << 5) - a) + b.charCodeAt(0)
            return a & a
          }, 0))
          const styleIndex = hash % 10
          return this.getSubjectStyleClass(styleIndex)
        }
      }
      
      // 默认不应用特殊样式
      return ''
    },

    // 获取论文具体信息
    async getPaperDetails (paperId) {
      try {
        console.log('获取论文详情，ID:', paperId)
        request('/api/Thesis/getThesisInfo', {
          thesis_id: paperId
        }).then((response) => {
          console.log('论文详情API响应:', response)
          if (response && Array.isArray(response) && response.length > 0) {
            const result = response[0]
            console.log('处理论文详情数据:', result)
            this.paperDetails = {
              ...result,
              paper_name: result.thesis_title,
              paper_author: result.author_arr ? result.author_arr.map(author => author.author_name).join(', ') : '',
              paper_abstract: result.thesis_summary ? result.thesis_summary.replace(/<[^>]*>/g, '') : '',
              paper_link: result.thesis_link,
              identification_number: result.thesis_doi,
              title: result.thesis_title,
              thesis_id: result.thesis_id,
              paper_id: result.thesis_id,
              // 保留原有字段以兼容现有功能
              bibliography: null // 新接口暂无参考文献数据
            }
            console.log('设置paperDetails:', this.paperDetails)
            this.processPaperDetails(this.paperDetails)
            
            // 处理doi链接
          let link = this.paperDetails.paper_link
          if (link?.startsWith('doi:')) {
            link = link.replace('doi:', '')
          }
          if (link?.startsWith('http://') || link?.startsWith('https://')) {
            this.isHttpLink = true
          } else {
            this.isHttpLink = false
          }
          this.paperDetails.paper_link = link
            console.log('论文详情设置完成，paperDetails存在:', !!this.paperDetails)
          } else {
            console.log('API响应格式错误或无数据:', response)
            this.$message.error('未找到论文详情')
          }
        }).catch((error) => {
          console.error('获取论文详情失败:', error)
          this.$message.error('获取论文详情失败，请稍后重试')
        })
      } catch (error) {
        console.error('获取论文详情异常:', error)
        this.$message.error('获取论文详情失败，请稍后重试')
      }
    },

    // 参考文献的details
    handleBibliographyDetails (value) {
      const reference = value.bibliography_content || value.bibliography
      // 提取作者名字
      const { authorName, articleTitle } =
        this.extractAuthorAndTitle(reference)
      this.paperDetails = {
        paper_name: articleTitle,
        paper_author: authorName
      }
      this.processPaperDetails(this.paperDetails)
    },

    // 处理高亮的标题和作者名
    processPaperDetails (paperDetails) {
      // 对paper_name属性进行处理
      paperDetails.paper_name = this.highlight(
        paperDetails.paper_name,
        this.keyword
      )
      paperDetails.paper_author = this.highlight(
        paperDetails.paper_author,
        this.keyword
      )
    },
    highlight (value, keyword) {
      const regex = new RegExp(keyword, 'gi')
      if (value != null) {
        return value.replace(
          regex,
          '<span style="background-color: yellow;">$&</span>'
        )
      }
    },

    // 取消点击
    closeClick (event) {
      // const isDot = event.target.classList.contains('dot')
      // if ((!isDot && this.selectedPaperId !== -1) ||
      //   this.selectedBibliographyNum !== -1) {
      //   this.selectedPaperId = -1
      //   this.selectedBibliographyNum = -1
      //   this.paperDetails = null
      // }
      this.paperDetails = null
    },

    // 关闭论文详情弹框
    closePaperDetails () {
      this.paperDetails = null
      this.selectedPaperId = -1
      this.selectedBibliographyNum = -1
      
      // 移除高亮效果
      removeAllHighlights()
    },

    // 点击圆点
    handleDotClick (value) {
      this.selectedBibliographyNum = -1
      this.selectedPaperId = -1
      // 使用thesis_id或paper_id
      const paperId = value.thesis_id || value.paper_id
      this.selectedPaperId = paperId
      this.getPaperDetails(paperId)
      
      // 添加高亮效果
      this.$nextTick(() => {
        highlightPaperDot(paperId.toString())
      })
      
      // 暂时注释掉导读功能，因为新接口可能不支持
      // this.getPaperIntroduction(paperId)
    },

    // 拆分文章标题和作者名
    extractAuthorAndTitle (bibliographyContent) {
      let authorName, articleTitle
      // 移除句首的序号
      const removeSerialNumber = bibliographyContent.replace(/^\d+\.\s*/, '')

      // 提取作者名
      const authorNameRegex = /\d+\.\s(.*?)\s\(/
      const authorNameMatch = bibliographyContent.match(authorNameRegex)
      authorName = authorNameMatch ? authorNameMatch[1] : ''

      // 提取文章标题
      // const articleTitleRegex = /\(\d+\)\.\s(.*?)\./;
      const articleTitleRegex = /\(\d+\)(.*)/
      const articleTitleMatch = removeSerialNumber.match(articleTitleRegex)
      // 如果年份在末尾的话，获取到的长度<=3
      if (articleTitleMatch && articleTitleMatch[1].length > 3) {
        articleTitle = articleTitleMatch[1]
      } else if (articleTitleMatch && articleTitleMatch[1].length <= 3) {
        const regex = /,(.*)/
        const match = removeSerialNumber.match(regex)
        if (match) {
          articleTitle = match[1]
        }
        // 第一个逗号之前的内容作为作者
        const regexAuthor = /([^,]+),/
        const matchAuthor = removeSerialNumber.match(regexAuthor)
        if (match) {
          authorName = matchAuthor[1]
        }
      } else {
        articleTitle = removeSerialNumber
      }

      // 匹配 空格al.空格 之后的内容，如有，作为标题
      const match = bibliographyContent.match(/(?<= al\. ).*/)
      if (match) {
        articleTitle = match[0]
      }

      // 匹配双引号，如有，双引号前面的表示作者，双引号内的表示标题
      // 提取双引号之前的内容
      const regexBeforeQuotes = /(.*?)(?=")/
      const beforeQuotesContent = removeSerialNumber.match(regexBeforeQuotes)
      if (beforeQuotesContent) {
        authorName = beforeQuotesContent[1]
      }
      // 提取双引号中的内容
      const regexQuotes = /"(.*?)"/g
      const quotesContents = removeSerialNumber
        .match(regexQuotes)
        ?.map((match) => match.slice(1, -1))
      if (quotesContents) {
        articleTitle = quotesContents
      }
      return { authorName, articleTitle }
    },

    // 点击详情里的参考文献
    clickBibliography (item, index) {
      this.selectedPaperId = -1
      this.selectedBibliographyNumPaperId = item.paper_id
      this.selectedBibliographyNum = index + 1
      this.handleBibliographyDetails(item)
    },

    // 选中分类
    handleClassify (value) {
      if (this.curClassify === value) {
        this.curClassify = -1
        this.getData()
      } else {
        this.curClassify = value
        this.getData(value)
      }
    },

    // 搜索（已废弃，现在使用本地过滤）
    changeSearchKeyWord () {
      this.selectedPaperId = -1
      this.selectedBibliographyNum = -1
      this.curClassify = -1
      this.paperDetails = null

      // 使用本地过滤而不是重新请求API
      if (this.keyword && this.keyword.trim()) {
        this.filterDataByKeyword(this.keyword.trim())
      } else {
        // 恢复所有数据
        if (this.allData) {
          const restoredData = JSON.parse(JSON.stringify(this.allData))
          this.$set(this, 'chartData', restoredData)
          this.initLazyLoading(restoredData)
        }
      }
    },
    // 清空搜索内容
    clearSearchBox () {
      this.keyword = ''
      this.chartData = this.allData
    },

    // 转换为word时的loading
    showLoading () {
      this.loadingInstance = Loading.service({
        fullscreen: true, // 是否全屏遮罩
        text: '加载中...', // 显示的文本
        background: 'rgba(0, 0, 0, 0.7)' // 遮罩的背景颜色
      })
    },
    hideLoading () {
      this.loadingInstance.close() // 关闭 Loading 实例
    },

    // 获取导读文章（暂时注释，等待新接口）
    async getPaperIntroduction (paperId) {
      // 暂时注释掉，等待新的导读接口
      // const params = {
      //   thesis_id: paperId
      // }
      // const result = await request('/api/Thesis/getPaperIntroduction', params)
      this.paperIntroductionList = []
    },

    // 点击导读文章
    clickPaperIntroductionList (item) {
      //
      this.apiCollectArticle(item)
      this.$router.push({
        path: '/editor',
        query: { articleId: item }
      })
    },

    // 收藏导读文章
    apiCollectArticle (item) {
      const params = {
        article_id: item.id,
        collect_member_id: item.member_id
      }
      request('/api/Paper/collectArticle', params).then((result) => {
        this.$message({
          message: '收藏文章成功',
          type: 'success',
          duration: 1000
        })
      }).catch((result) => {
        this.$message({
          message: result.message,
          type: 'error',
          duration: 1000
        })
      })
    },

    //     // 点击文章标题，如有url，跳转显示
    clickPaperTitle (paperData) {
      if (paperData.paper_link || paperData.thesis_link) {
        const link = paperData.paper_link || paperData.thesis_link
        const el = document.createElement('a')
        el.href = link
        el.target = '_blank'
        el.click()
      } else {
        this.$message({
          message: '暂无链接',
          type: 'error',
          duration: 1000
        })
      }
    }
  },

  computed: {
    sortedYears () {
      const years = Object.keys(this.chartData).sort((a, b) => b - a) // 对年份进行降序排序
      return years
    },
    
    visibleYears () {
      // 只显示有数据的年份，限制为前30个年份以保持性能
      return this.sortedYears.slice(0, 30)
    },
    
    // 缓存年份数据，避免重复计算
    cachedYearData () {
      const cache = {}
      for (const year of this.visibleYears) {
        cache[year] = this.visibleData[year] || []
      }
      return cache
    }
  },
  watch: {
    keyword (newVal, oldVal) {
      // 如果关键词为空，清空关键词列表，但不改变时间轴
      if (!newVal || newVal.trim() === '') {
        this.tagList = [] // 清空关键词列表
      }
    }
  },
  mounted () {
    this.getData()
    this.getCategoryList()
  }
}
</script>

<style lang="scss" scoped>
.container {
  background-color: white;
  width: 100vw;
  height: 100vh;
  display: flex;
  justify-content: flex-start;
  /* 靠左对齐 */
  align-items: center;
  /* 垂直居中 */
}
.el-popper{
  background-color: #ffffff !important;
  border: 1px solid #e0e0e0 !important;
  z-index: 9999 !important;
}
.el-autocomplete-suggestion{
  background-color: #ffffff !important;
  border: 1px solid #e0e0e0 !important;
  z-index: 9999 !important;
}
.el-autocomplete-suggestion.is-loading li:hover{
  background-color: #f5f5f5 !important;
}
.el-input__inner{
  height: 36px;
  color: #333;
  background-color: #ffffff;
  border: 1px solid #ddd;
}
.el-popper[x-placement^=bottom] .popper__arrow{
  border-bottom-color: #ffffff !important;
}
.el-popper[x-placement^=bottom] .popper__arrow::after {
  border-bottom-color: #ffffff !important;
}
.el-autocomplete-suggestion__list{
  background-color: #ffffff !important;
}
.el-autocomplete-suggestion__list li{
  color: #333 !important;
  background-color: #ffffff !important;
  padding: 8px 12px !important;
}
.el-autocomplete-suggestion li:hover {
  background-color: #f5f5f5 !important;
}

/* 搜索项样式 */
.search-item {
  display: flex;
  align-items: center;
  padding: 4px 0;
  
  .search-item-type {
    margin-right: 8px;
    font-size: 14px;
  }
  
  .search-item-content {
    flex: 1;
    color: #fff;
  }
  
  &.thesis {
    .search-item-content {
      color: #87ceeb; /* 浅蓝色表示论文 */
    }
  }
  
  &.tag {
    .search-item-content {
      color: #98fb98; /* 浅绿色表示标签 */
    }
  }
}

/* 关键词列表样式 */
.tag-list-container {
  position: fixed;
  left: 2vw;
  right: 2vw;
  top: 70px;
  z-index: 9;
  width: calc(100vw - 4vw);
  
  .tag-list-header {
    display: flex;
    justify-content: space-between;
    align-items: center;
    margin-bottom: 8px;
    
    .tag-list-title {
      color: #333;
      font-size: 14px;
      font-weight: 500;
    }
    
    .tag-list-controls {
      display: flex;
      gap: 8px;
      align-items: center;
    }
    
    .collapse-btn,
    .analyze-btn,
    .reset-btn {
      color: #333;
      font-size: 12px;
      background-color: #f8f9fa;
      padding: 4px 8px;
      border-radius: 12px;
      cursor: pointer;
      transition: all 0.3s ease;
      border: 1px solid #dee2e6;
      
      &:hover {
        background-color: #e9ecef;
        transform: scale(1.05);
      }
    }
    
    .collapse-btn {
      background-color: #e9ecef;
      border-color: #adb5bd;
      
      &:hover {
        background-color: #dee2e6;
      }
    }
    
    .analyze-btn {
      background-color: #e9ecef;
      border-color: #adb5bd;
      
      &:hover {
        background-color: #dee2e6;
      }
    }
    

  }
  
  .tag-list {
    display: flex;
    flex-wrap: wrap;
    gap: 8px;
    max-height: 150px;
    overflow-y: auto;
    padding: 8px;
    background-color: #f8f9fa;
    border-radius: 8px;
    border: 1px solid #dee2e6;
    transition: all 0.3s ease;
    
    .tag-item {
      display: inline-block;
      background-color: #e9ecef;
      color: #333;
      padding: 4px 12px;
      border-radius: 16px;
      font-size: 12px;
      cursor: pointer;
      transition: all 0.3s ease;
      border: 1px solid #adb5bd;
      
      &:hover {
        background-color: #dee2e6;
        transform: translateY(-1px);
        box-shadow: 0 2px 8px rgba(173, 181, 189, 0.4);
      }
      
      &:active {
        transform: translateY(0);
      }
    }
  }
}

.image-container {
  position: relative;
  width: 100vw;
  max-height: 100%;

  img {
    width: 100vw;
    opacity: 0.8;
    height: auto;
  }
}

.search-box {
  position: fixed;
  // left: 300px;
  top: 25px;
  display: flex;
  align-items: center;
  height: 28px;
  padding: 0 6px;
  // background: rgb(255, 242, 204);
  // border-radius: 3px;
  // box-shadow: 0 0 1px 2px #494949;
  // margin-left: 30px;
  transform: translateY(5px);
  z-index: 10;
  .inline-input{
    width: 420px;
  }
  .el-input__inner{
    background-color: #ffffff;
    box-shadow: 0 0 1px 2px #e0e0e0;
    border: 1px solid #ddd;
  }
  .icon {
    width: 22px;
    height: 22px;
    position: absolute;
    top: 8px;

    &:last-of-type {
      cursor: pointer;
    }
  }

  .input {
    height: 24px;
    line-height: 24px;
    border: none;
    background: transparent;
    padding: 0 10px;

    &:focus {
      outline: none;
    }

    color: white;
  }
}

.paper-chart {
  position: absolute;
  width: 65vw;
  left: 2vw;
  bottom: 9vh;
  color: white;
  display: flex;
  flex-direction: column;
  transition: bottom 0.3s ease;
  
  &.has-keywords {
    bottom: 20vh; /* 当有关键词时，向下移动更多空间 */
  }

  .paper-chart-content {
    height: 77vh;
    overflow-y: auto;
    overflow-x: hidden;
    transition: height 0.3s ease;
  }
  
  &.has-keywords .paper-chart-content {
    height: 66vh; /* 当有关键词时，减少高度 */
  }

  .paper-chart-year {
    color: #666;
    font-size: 14px;
    display: inline-block;
    margin-right: 8px;
    border-right: 1px dashed #adb5bd;
    width: 45px;
    // height: 3vh;
  }

  .year-row {
    display: flex;
    margin-bottom: 8px;
  }

  .paper-chart-dot {
    width: 55vw;
    display: flex;
    flex-wrap: wrap;
    align-items: flex-start;
    min-height: 20px;
    position: relative;
  }

  .triangle {
    top: -10px;
    left: 40px;
    position: absolute;
    width: 0;
    height: 0;
    border-left: 6px solid transparent;
    border-right: 6px solid transparent;
    border-bottom: 10px solid #6c757d;
  }

  .circle {
    width: 8px;
    height: 8px;
    left: 41px;
    bottom: -10px;
    position: absolute;
    border-radius: 50%;
    background-color: #6c757d;
  }

  .dot {
    display: inline-block;
    width: 10px;
    height: 10px;
    border-radius: 50%;
    background-color: #adb5bd;
    margin: 1px 2px 1px 0;
    position: relative;
    cursor: pointer;
    flex-shrink: 0;
    border: 1px solid #6c757d;
    overflow: hidden;
  }

  /* 论文点继承分类样式 - 适配圆形显示 */
  
  /* 样式1：浅灰点状 */
  .dot.subject-style-1 {
    background: radial-gradient(circle, #6c757d 0.5px, transparent 0.5px);
    background-size: 4px 4px;
    background-color: #f8f9fa;
    border: 1px solid #6c757d;
  }

  /* 样式2：中灰竖条纹 */
  .dot.subject-style-2 {
    background: linear-gradient(90deg, #495057 1px, transparent 0.5px);
    background-size: 3px 100%;
    background-color: #e9ecef;
    border: 1px solid #495057;
  }

  /* 样式3：深灰横条纹 */
  .dot.subject-style-3 {
    background: linear-gradient(0deg, #343a40 1px, transparent 0.5px);
    background-size: 100% 3px;
    background-color: #dee2e6;
    border: 1px solid #343a40;
  }

  /* 样式4：浅灰斜条纹 */
  .dot.subject-style-4 {
    background: linear-gradient(45deg, #adb5bd 25%, transparent 25%, transparent 75%, #adb5bd 75%);
    background-size: 4px 4px;
    background-color: #f8f9fa;
    border: 1px solid #adb5bd;
  }

  /* 样式5：中灰网格 */
  .dot.subject-style-5 {
    background: 
      linear-gradient(to right, #6c757d 0.5px, transparent 0.5px),
      linear-gradient(to bottom, #6c757d 0.5px, transparent 0.5px);
    background-size: 4px 4px;
    background-color: #e9ecef;
    border: 1px solid #6c757d;
  }

  /* 样式6：深灰密集点 */
  .dot.subject-style-6 {
    background: radial-gradient(circle, #495057 0.8px, transparent 0.5px);
    background-size: 3px 3px;
    background-color: #dee2e6;
    border: 1px solid #495057;
  }

  /* 样式7：浅灰菱形格 */
  .dot.subject-style-7 {
    background: 
      linear-gradient(45deg, transparent 30%, #adb5bd 30%, #adb5bd 70%, transparent 70%),
      linear-gradient(-45deg, transparent 30%, #adb5bd 30%, #adb5bd 70%, transparent 70%);
    background-size: 5px 5px;
    background-color: #f8f9fa;
    border: 1px solid #adb5bd;
  }

  /* 样式8：中灰大点 */
  .dot.subject-style-8 {
    background: radial-gradient(circle, #6c757d 1px, transparent 0.5px);
    background-size: 6px 6px;
    background-color: #e9ecef;
    border: 1px solid #6c757d;
  }

  /* 样式9：深灰交叉格 */
  .dot.subject-style-9 {
    background: 
      linear-gradient(45deg, #495057 1px, transparent 0.5px),
      linear-gradient(-45deg, #495057 1px, transparent 0.5px);
    background-size: 4px 4px;
    background-color: #dee2e6;
    border: 1px solid #495057;
  }

  /* 样式10：浅灰波点 */
  .dot.subject-style-10 {
    background: 
      radial-gradient(circle at 25% 25%, #adb5bd 0.5px, transparent 0.5px),
      radial-gradient(circle at 75% 75%, #adb5bd 0.5px, transparent 0.5px);
    background-size: 5px 5px;
    background-color: #f8f9fa;
    border: 1px solid #adb5bd;
  }

  .selected {
    background-color: #f17723 !important;
  }

  .selectedBibliography {
    background-color: #00b0f0 !important;
  }

  .load-more-btn {
    display: inline-flex;
    align-items: center;
    justify-content: center;
    min-width: 24px;
    height: 12px;
    background-color: #4472c4;
    color: white;
    font-size: 10px;
    font-weight: bold;
    border-radius: 6px;
    cursor: pointer;
    margin: 1px 4px 1px 2px;
    padding: 0 4px;
    transition: all 0.2s;
    
    &:hover {
      background-color: #365a9b;
      transform: scale(1.05);
    }
    
    .loading {
      animation: pulse 1s infinite;
    }
  }

  @keyframes pulse {
    0%, 100% { opacity: 1; }
    50% { opacity: 0.5; }
  }

  .tooltip {
    position: absolute;
    padding: 2px 4px;
    height: auto;
    width: auto;
    max-width: 220px;
    max-height: 40px;
    font-size: 12px;
    color: black;
    display: flow-root;
    white-space: nowrap;
    background-color: white;
    overflow: hidden;
    text-overflow: ellipsis;
  }
}

.paper-details {
  position: absolute;
  right: 2vw;
  top: 3vw;
  padding: 15px;
  background-color: white;
  width: 30vw;
  max-height: 85vh;
  font-size: 14px;
  border-radius: 8px;
  box-shadow: 0 4px 20px rgba(0, 0, 0, 0.15);
  z-index: 1000;
  overflow-y: auto;

  .paper-details-header {
    display: flex;
    justify-content: space-between;
    align-items: flex-start;
    margin-bottom: 10px;
  }

  .paper-details-title {
    font-size: 18px;
    font-family: math;
    word-break: break-all;
    cursor: pointer;
    flex: 1;
    margin-right: 10px;
  }

  .paper-details-close {
    cursor: pointer;
    font-size: 24px;
    color: #999;
    font-weight: bold;
    padding: 0 5px;
    border-radius: 50%;
    transition: all 0.2s;
    
    &:hover {
      background-color: #f5f5f5;
      color: #333;
    }
  }

  .paper-details-doi {
    margin-top: 10px;

    .paper-details-doi-title {
      color: #7b788a;
    }

    .paper-details-doi-link {
      // text-decoration: none;
      // color: inherit;
      word-wrap: break-word;
      color: #ff3905;
    }
  }

  .paper-details-author {
    color: #4387cf;
    font-weight: 600;
    // margin: 10px 0;
    max-height: 4vh;
    overflow-y: scroll;
  }

  .paper-details-subtitle {
    font-weight: 600;
    margin: 3px 0;
  }

  .paper-details-abstract {
    max-height: 25vh;
    overflow-y: scroll;
  }

  .paper-details-reference {
    max-height: 25vh;
    overflow-y: scroll;
  }

  // 新增样式
  .paper-details-tags {
    max-height: 10vh;
    overflow-y: scroll;
    
    .tag-item {
      display: inline-block;
      background-color: #e8f4fd;
      color: #1890ff;
      padding: 2px 8px;
      margin: 2px 4px 2px 0;
      border-radius: 12px;
      font-size: 12px;
    }
  }

  .paper-details-subjects {
    max-height: 8vh;
    overflow-y: scroll;
    
    .subject-item {
      display: inline-block;
      background-color: #f6ffed;
      color: #52c41a;
      padding: 2px 8px;
      margin: 2px 4px 2px 0;
      border-radius: 12px;
      font-size: 12px;
    }
  }

  .paper-details-journal {
    color: #722ed1;
    font-weight: 500;
    font-style: italic;
  }

  // 导读
  .paperIntroduction {
    display: flex;
    align-items: center;

    .paperIntroduction-left {
      color: white;
      background-color: #2c76b6;
      width: 30px;
      padding: 2px 5px;
      border-radius: 5px;
      height: 20px;
      margin-right: 5px;
    }

    .paperIntroduction-right {
      width: 335px;
      max-height: 50px;
      overflow-y: scroll;
    }

    .paperIntroduction-right-item {
      cursor: pointer;
      font-weight: 600;
      white-space: nowrap;
      /* 禁止换行 */
      overflow: hidden;
      /* 隐藏溢出部分 */
      text-overflow: ellipsis;
      /* 显示省略号 */
    }
  }
}

.category-list {
  display: flex;
  /* color: white; */
  position: fixed;
  bottom: 2vh;
  left: 28vh;
  width: 80vw;
  overflow-x: scroll;

  .category-item {
    color: #0070c0;
    margin-right: 10px;
    border: 1px solid;
    padding: 0px 5px;
    font-size: 15px;
    border-radius: 5px;
    cursor: pointer;
    white-space: nowrap;
  }

  .category-item-active {
    background-color: #2a75b5;
    color: white;
    border: 1px solid #2a75b5;
  }
}

@media (max-width: 600px) {
  .category-list {
    bottom: 25px;
    left: 5px;
    width: 100vw;
  }

  .paper-details {
    width: 50vw;
    max-height: 83vh;
    top: 20vw;
    z-index: 10;
  }

  .paper-details-abstract {
    max-height: 20vh !important;
    overflow-y: scroll !important;
  }

  .paper-details-reference {
    max-height: 20vh !important;
    overflow-y: scroll !important;
  }

  .paper-details-tags {
    max-height: 8vh !important;
    overflow-y: scroll !important;
  }

  .paper-details-subjects {
    max-height: 6vh !important;
    overflow-y: scroll !important;
  }
}

.no-scroll-bar::-webkit-scrollbar {
  display: none;
}

/* 分析结果弹窗样式 */
.analysis-modal {
  position: fixed;
  right: 2vw;
  top: 10vh;
  width: 35vw;
  max-height: 80vh;
  background: #6a6a6a;
  backdrop-filter: blur(10px);
  border-radius: 12px;
  border: 1px solid rgba(255, 255, 255, 0.2);
  z-index: 1000;
  box-shadow: 0 8px 32px rgba(0, 0, 0, 0.3);
  animation: slideInRight 0.3s ease-out;
}

@keyframes slideInRight {
  from {
    transform: translateX(100%);
    opacity: 0;
  }
  to {
    transform: translateX(0);
    opacity: 1;
  }
}

.analysis-modal-header {
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 16px 20px;
  border-bottom: 1px solid rgba(255, 255, 255, 0.1);
  background: rgba(255, 255, 255, 0.05);
  border-radius: 12px 12px 0 0;
}

.analysis-modal-title {
  font-size: 16px;
  font-weight: bold;
  color: #ffffff;
}

.analysis-modal-controls {
  display: flex;
  gap: 8px;
}

.analysis-modal-minimize {
  padding: 6px 12px;
  background: rgba(255, 255, 255, 0.1);
  border: 1px solid rgba(255, 255, 255, 0.2);
  border-radius: 6px;
  color: #ffffff;
  font-size: 12px;
  cursor: pointer;
  transition: all 0.2s ease;
}

.analysis-modal-minimize:hover {
  background: rgba(255, 255, 255, 0.2);
  transform: translateY(-1px);
}

.analysis-modal-content {
  padding: 20px;
  max-height: calc(80vh - 120px);
  overflow-y: auto;
}

.analysis-content {
  color: #ffffff;
}

.analysis-summary {
  margin-bottom: 24px;
  padding: 16px;
  background: rgba(255, 255, 255, 0.05);
  border-radius: 8px;
  border: 1px solid rgba(255, 255, 255, 0.1);
}

.analysis-summary h4 {
  margin: 0 0 12px 0;
  color: #ffffff;
  font-size: 14px;
}

.summary-stats {
  display: flex;
  flex-wrap: wrap;
  gap: 12px;
}

.stat-item {
  padding: 6px 12px;
  background: rgba(255, 255, 255, 0.1);
  border: 1px solid rgba(255, 255, 255, 0.2);
  border-radius: 16px;
  font-size: 12px;
  color: #ffffff;
}

.analysis-sections {
  display: flex;
  flex-direction: column;
  gap: 20px;
}

.analysis-section {
  background: rgba(255, 255, 255, 0.03);
  border-radius: 8px;
  border: 1px solid rgba(255, 255, 255, 0.1);
  overflow: hidden;
}

.section-title {
  margin: 0;
  padding: 12px 16px;
  background: rgba(255, 255, 255, 0.08);
  color: #ffffff;
  font-size: 14px;
  font-weight: bold;
  border-bottom: 1px solid rgba(255, 255, 255, 0.1);
}

.section-content {
  padding: 16px;
  line-height: 1.6;
  font-size: 13px;
  color: #ffffff;
}

.section-content strong {
  color: #ffffff;
  font-weight: bold;
}

.analysis-error {
  text-align: center;
  padding: 40px 20px;
}

.error-message {
  color: #ffffff;
  font-size: 16px;
  margin-bottom: 12px;
}

.error-details {
  color: #ffffff;
  font-size: 12px;
}

/* 分析结果切换按钮 */
.analysis-toggle-btn {
  position: fixed;
  right: 2vw;
  top: 10vh;
  padding: 12px 16px;
  background: #6a6a6a;
  backdrop-filter: blur(5px);
  border: 1px solid rgba(255, 255, 255, 0.2);
  border-radius: 8px;
  color: #ffffff;
  font-size: 14px;
  font-weight: bold;
  cursor: pointer;
  z-index: 999;
  transition: all 0.3s ease;
  animation: pulse 2s infinite;
}

.analysis-toggle-btn:hover {
  background: #7a7a7a;
  transform: translateY(-2px);
  box-shadow: 0 4px 16px rgba(0, 0, 0, 0.4);
}

@keyframes pulse {
  0%, 100% {
    box-shadow: 0 0 0 0 rgba(255, 255, 255, 0.3);
  }
  50% {
    box-shadow: 0 0 0 10px rgba(255, 255, 255, 0);
  }
}

/* 响应式设计 */
@media (max-width: 1200px) {
  .analysis-modal {
    width: 40vw;
  }
}

@media (max-width: 768px) {
  .analysis-modal {
    right: 1vw;
    width: 45vw;
    top: 8vh;
    max-height: 85vh;
  }
  
  .analysis-toggle-btn {
    right: 1vw;
    top: 8vh;
    padding: 10px 12px;
    font-size: 12px;
  }
  
  .summary-stats {
    flex-direction: column;
    gap: 8px;
  }
  
  .stat-item {
    text-align: center;
  }
}

/* 论文分类展示样式 */
.thesis-subject-container {
  position: fixed;
  top: 10vh;
  right: 2vw;
  width: 28vw;
  max-height: 70vh;
  z-index: 5;
  background: #f8f9fa;
  border-radius: 6px;
  border: 1px solid #dee2e6;
  overflow: hidden;
  transition: all 0.3s ease;
}

.subject-toggle-btn {
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 6px 12px;
  background: #e9ecef;
  cursor: pointer;
  transition: all 0.2s ease;
  border-bottom: 1px solid #dee2e6;
  
  &:hover {
    background: #dee2e6;
  }
  
  .toggle-icon {
    color: #6c757d;
    font-size: 12px;
    transition: transform 0.2s ease;
    
    &.collapsed {
      transform: rotate(180deg);
    }
  }
  
  .toggle-text {
    color: #333;
    font-size: 11px;
    font-weight: 500;
  }
}

.thesis-subject-list {
  display: flex;
  flex-wrap: wrap;
  gap: 4px;
  padding: 6px;
  max-height: 60vh;
  overflow-y: auto;
  transition: all 0.3s ease;
  
  &.collapsed {
    max-height: 0; /* 完全隐藏 */
    overflow: hidden;
    padding: 0; /* 折叠时移除内边距 */
  }
}

.thesis-subject-item {
  padding: 3px 8px;
  border-radius: 12px;
  color: #333;
  font-size: 10px;
  font-weight: 500;
  cursor: pointer;
  transition: all 0.2s ease;
  border: 1px solid #adb5bd;
  background-color: #ffffff;
  position: relative;
  overflow: hidden;
  white-space: nowrap;
  
  &:hover {
    transform: translateY(-1px);
    box-shadow: 0 2px 6px rgba(173, 181, 189, 0.3);
    border-color: #6c757d;
    background-color: #e9ecef;
  }
}

/* 10种不同的分类样式 - 深浅不同、点状和格栅底纹 */

/* 样式1：浅灰点状 */
.subject-style-1 {
  background: radial-gradient(circle, #6c757d 1px, transparent 1px);
  background-size: 8px 8px;
  background-color: #f8f9fa;
  border: 1px solid #6c757d;
  border-radius: 6px;
}

/* 样式2：中灰竖条纹 - 改善可读性 */
.subject-style-2 {
  background: linear-gradient(90deg, #6c757d 1px, transparent 1px);
  background-size: 8px 100%;
  background-color: #f8f9fa;
  border: 1px solid #6c757d;
  border-radius: 6px;
}

/* 样式3：深灰横条纹 - 改善可读性 */
.subject-style-3 {
  background: linear-gradient(0deg, #6c757d 1px, transparent 1px);
  background-size: 100% 8px;
  background-color: #f8f9fa;
  border: 1px solid #6c757d;
  border-radius: 6px;
}

/* 样式4：浅灰斜条纹 */
.subject-style-4 {
  background: linear-gradient(45deg, #adb5bd 25%, transparent 25%, transparent 75%, #adb5bd 75%);
  background-size: 8px 8px;
  background-color: #f8f9fa;
  border: 1px solid #adb5bd;
  border-radius: 6px;
}

/* 样式5：中灰网格 */
.subject-style-5 {
  background: 
    linear-gradient(to right, #6c757d 1px, transparent 1px),
    linear-gradient(to bottom, #6c757d 1px, transparent 1px);
  background-size: 8px 8px;
  background-color: #e9ecef;
  border: 1px solid #6c757d;
  border-radius: 6px;
}

/* 样式6：深灰密集点 */
.subject-style-6 {
  background: radial-gradient(circle, #495057 1.5px, transparent 1.5px);
  background-size: 6px 6px;
  background-color: #dee2e6;
  border: 1px solid #495057;
  border-radius: 6px;
}

/* 样式7：浅灰菱形格 */
.subject-style-7 {
  background: 
    linear-gradient(45deg, transparent 30%, #adb5bd 30%, #adb5bd 70%, transparent 70%),
    linear-gradient(-45deg, transparent 30%, #adb5bd 30%, #adb5bd 70%, transparent 70%);
  background-size: 10px 10px;
  background-color: #f8f9fa;
  border: 1px solid #adb5bd;
  border-radius: 6px;
}

/* 样式8：中灰大点 */
.subject-style-8 {
  background: radial-gradient(circle, #6c757d 2px, transparent 2px);
  background-size: 12px 12px;
  background-color: #e9ecef;
  border: 1px solid #6c757d;
  border-radius: 6px;
}

/* 样式9：深灰交叉格 */
.subject-style-9 {
  background: 
    linear-gradient(45deg, #495057 2px, transparent 2px),
    linear-gradient(-45deg, #495057 2px, transparent 2px);
  background-size: 8px 8px;
  background-color: #dee2e6;
  border: 1px solid #495057;
  border-radius: 6px;
}

/* 样式10：浅灰波点 */
.subject-style-10 {
  background: 
    radial-gradient(circle at 25% 25%, #adb5bd 1px, transparent 1px),
    radial-gradient(circle at 75% 75%, #adb5bd 1px, transparent 1px);
  background-size: 10px 10px;
  background-color: #f8f9fa;
  border: 1px solid #adb5bd;
  border-radius: 6px;
}

/* 悬停效果 */
.thesis-subject-item:hover {
  background-color: #e9ecef !important;
  border-color: #adb5bd !important;
  transition: all 0.2s ease;
}
/* 分类选中状态样式 - 橘色高亮 */
.thesis-subject-item.selected {
  background: #ff6b35 !important;
  color: #ffffff !important;
  border-color: #e55a2b !important;
  box-shadow: 0 0 8px rgba(255, 107, 53, 0.4) !important;
  transform: translateY(-1px) !important;
}

.thesis-subject-item.selected:hover {
  background: #e55a2b !important;
  border-color: #cc4e24 !important;
  box-shadow: 0 2px 12px rgba(229, 90, 43, 0.6) !important;
}


/* 响应式设计 */
@media (max-width: 768px) {
  .thesis-subject-container {
    top: 12vh;
    right: 1vw;
    width: 35vw;
    max-height: 60vh;
  }
  
  .thesis-subject-list.collapsed {
    max-height: 0;
    padding: 0;
  }
  
  .thesis-subject-list {
    max-height: 50vh;
  }
  
  .thesis-subject-item {
    padding: 2px 6px;
    font-size: 9px;
  }
  
  .subject-toggle-btn {
    padding: 4px 8px;
  }
  
  .toggle-text {
    font-size: 10px;
  }
}
</style>

